import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=e0d6765c&scoped=true&"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=e0d6765c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d6765c",
  null
  
)

export default component.exports